export default __webpack_public_path__ + "static/media/alta_masiva.40a75b3a.xlsx";